<template>
  <div>
    <b-table v-if="!isLoading" :fields="fields" :items="items" head-variant="light" hover responsive>
      <template v-slot:cell(values)="linha">      
        <b-btn variant="light mr-2" size="sm" pill @click="loadValues(linha)">
          <i class="fas fa-chevron-circle-down"/>
        </b-btn>
      </template>
      <template v-slot:cell(created_at)="linha">
        {{ linha.item.created_at| formatDate }}
      </template>
      <template v-slot:cell(updated_at)="linha">
        {{ linha.item.updated_at| formatDate }}
      </template>

      <template v-slot:row-details="{item}">
        <b-card class="p-0">
          <div class="p-3">
            <b-row class="card-row-spacing">
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.evento') }}:</strong> {{ item.event }}
              </b-col>
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.atualizado_em') }}:</strong> {{ item.updated_at | formatDate }}                
              </b-col>
            </b-row>
            <b-row class="card-row-spacing">
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.modelo') }}:</strong> {{ item.auditable_type }}
              </b-col>
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.chave_modelo') }}:</strong> {{ item.auditable_id }}
              </b-col>
            </b-row>
            <b-row class="card-row-spacing">
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.veus_id') }}:</strong> {{ item.user_id }}                
              </b-col>
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.usuario') }}:</strong> {{ item.user_name }}                
              </b-col>
            </b-row>
            <b-row class="card-row-spacing">
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.valores_antigos') }}:</strong> {{ item.old_values }}                
              </b-col>
              <b-col cols="12" md="6">                
                <strong>{{ $t('logs.tabela.campos.novos_valores') }}:</strong> {{ item.new_values}}
              </b-col>
            </b-row>
            <b-row class="card-row-spacing">
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.url') }}:</strong> {{ item.url }}                
              </b-col>
              <b-col cols="12" md="6">                
                <strong>{{ $t('logs.tabela.campos.user_agent') }}:</strong> {{ item.user_agent}}
              </b-col>
            </b-row>
            <b-row class="card-row-spacing">
              <b-col cols="12" md="6">
                <strong>{{ $t('logs.tabela.campos.ip') }}:</strong> {{ item.ip_address }}                
              </b-col>
              <b-col cols="12" md="6">                
                <strong>{{ $t('logs.tabela.campos.criado_em') }}:</strong> {{ item.created_at | formatDate }}
              </b-col>
            </b-row>
            <b-row class="card-row-spacing">
              <b-col cols="12" md="12">
                <strong>{{ $t('logs.tabela.campos.tags') }}:</strong> {{ item.tags }}                
              </b-col>              
            </b-row>
          </div>
        </b-card>
      </template>
    </b-table>
    <Loading v-else/>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import moment from "moment";

export default {
  name: "Table",
  components: {
    Loading,
    moment
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    additionalFields: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {
          key: 'values',
          label: ""
        },
        {
          key: 'event',
          label: this.$t('logs.tabela.campos.evento')
        },
        {
          key: 'auditable_type',
          label: this.$t('logs.tabela.campos.modelo')
        },
        {
          key: 'auditable_id',
          label: this.$t('logs.tabela.campos.chave_modelo')
        },
        {
          key: 'user_id',
          label: this.$t('logs.tabela.campos.veus_id')
        },
        {
          key: 'user_name',
          label: this.$t('logs.tabela.campos.usuario')
        },
        {
          key: 'updated_at',
          label: this.$t('logs.tabela.campos.atualizado_em')
        }
      ]
    }
  },
  methods: {
    async loadValues(linha) {
      linha.toggleDetails()      
    },
  },
  mounted() {
    this.fields = [...this.fields, ...this.additionalFields]
  }
}
</script>

<style lang="scss" scoped>
.badge {
  color: #dddfeb;
  padding: 0.40em;

  i {
    font-size: 1.5em;
  }
}

.badge-danger {
  background-color: #ffe1de;
  color: #e74a3b;
}

.badge-success {
  background-color: #d8fbee;
  color: #1cc88a;
}

.card-row-spacing {
  margin-bottom: 1.5rem;
}
</style>
